import p1 from "../assets/images/l2.jpeg";
import p2 from "../assets/images/ll1.jpeg";
import p3 from "../assets/images/l3.jpeg";
import p4 from "../assets/images/l4.jpeg";
import p5 from "../assets/images/Diacorex-tablett.jpeg";
import p16 from "../assets/images/shilajit-plus.png";
import p17 from "../assets/images/stamina.png";

import p6 from "../assets/images/l5.jpeg";
import p7 from "../assets/images/l6.jpeg";
import p8 from "../assets/images/l8.jpeg";
import p9 from "../assets/images/l9.jpeg";
import p10 from "../assets/images/l10.jpeg";
import p11 from "../assets/images/l11.jpeg";
import p12 from "../assets/images/l12.jpeg";
import p13 from "../assets/images/l13.jpeg";
import p14 from "../assets/images/l14.jpeg";
import p15 from "../assets/images/l15.jpeg";

export const products = [
  {
    id: 1,
    name: "Madhumeh (Sugar) Powder",
    slug: "madhumeh-sugar-powder",
    price: 1699,
    oldPrice: 1999,
    img: p1,
    images: [p1, p6, p7],
    description: "Improves blood sugar control naturally.",
  },
  {
    id: 2,
    name: "Pachan Care Powder",
    slug: "paachan-care-powder",
    price: 1299,
    oldPrice: 1999,
    img: p2,
    images: [p2, p8, p9],
    description: "Relieves acidity and improves digestion.",
  },
  {
    id: 3,
    name: "Liver Care Tablet",
    slug: "liver-care-tablet",
    price: 1299,
    oldPrice: 1999,
    img: p3,
    images: [p3, p10, p11],
    description: "Supports detox and liver health.",
  },
  {
    id: 4,
    name: "Diacare Powder",
    slug: "diacare-powder",
    price: 1699,
    oldPrice: 1999,
    img: p4,
    images: [p4, p12, p13],
    description: "Helps manage blood sugar levels.",
  },
  {
    id: 5,
    name: "Diacorex Tablet",
    slug: "diacorex-tablet",
    price: 1499,
    oldPrice: 1999,
    img: p5,
    images: [p5, p14, p15],
    description: "Advanced insulin support formula.",
  },
  {
    id: 6,
    name: "SHILAJIT+",
    slug: "shilajit-plus",
    price: 1999,
    oldPrice: 2499,
    img: p16,
    images: [p16],
    description: "Enhances stamina & vitality naturally.",
  },
  {
    id: 7,
    name: "STAMINA",
    slug: "stamina",
    price: 999,
    oldPrice: 1499,
    img: p17,
    images: [p17],
    description: "Ayurvedic Calcium and Iron Supplement.",
  },
];
